import React, { FC } from 'react';
import { Grid } from 'semantic-ui-react';
import Subtitle from 'components/Subtitle';
import FieldText from './FieldText';

const ContactInfo: FC = () => {
    return (
        <>
            <Subtitle title="Yhteystiedot" />
            <Grid columns={2} stretched stackable>
                <Grid.Column>
                    <FieldText name="etunimi" title="Etunimi" required />
                </Grid.Column>
                <Grid.Column>
                    <FieldText name="sukunimi" title="Sukunimi" required />
                </Grid.Column>
                <Grid.Row>
                    <Grid.Column>
                        <FieldText name="puhelin" title="Puhelinnumero" required />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={1}>
                    <Grid.Column>
                        <FieldText name="email" title="Sähköposti" required />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </>
    );
};

export default ContactInfo;
